import { View } from "../../Core";
import Vue from "vue";

class ViewDataModel {
    public shouldShowPayerInfo: Boolean;
}

export class GroupTypeView extends View<GroupTypeView> {
    private _viewData: ViewDataModel = window.__VIEW_DATA;

    public constructor() {
        super();
        this.SetupVue();
    }

    SetupVue() {
        let v = new Vue({
            el: ".app",
            data: {
                showLongDescription: false
            },
        });
    }
}


// WEBPACK FOOTER //
// ./www/js/Pages/Club/GroupTypeView.ts